import { changeToMrStructure } from '@/pages/User/pages/MergeRequests/mapMergeRequest'
import { SetDiffItem } from '@/pages/User/pages/Releases/setDiff'
import {
	BranchStructureChangeDto,
	StructureMetadataDtoRead,
} from '@/rtkApi/mddApiSliceGeneratedV2'

export const toSetDiffItems = (
	nodes: StructureMetadataDtoRead[] | undefined,
): SetDiffItem[] =>
	(nodes ?? [])
		.filter(
			(node) =>
				node.id != null && node.type != null && node.type !== 'SYSTEM',
		)
		.map((node) => ({
			structureId: String(node.id),
			structureHistoryId: node.lastModifiedTime ?? node.status ?? String(node.id),
			type: String(node.type),
			code: node.code ?? '',
			name: node.name ?? node.code ?? String(node.id),
		}))

const changeItem = (
	change: BranchStructureChangeDto,
	historyId: string,
): SetDiffItem => ({
	structureId: String(change.structureId),
	structureHistoryId: historyId,
	type: changeToMrStructure(change).type,
	code: change.code ?? '',
	name: change.name ?? change.code ?? String(change.structureId),
})

export const toSetDiffFromChanges = (
	changes: BranchStructureChangeDto[] | undefined,
): { branchA: SetDiffItem[]; branchB: SetDiffItem[] } => {
	const branchA: SetDiffItem[] = []
	const branchB: SetDiffItem[] = []

	for (const change of changes ?? []) {
		if (change.structureId == null) continue
		switch (change.changeType) {
			case 'ADDED':
				branchB.push(changeItem(change, String(change.currentVersion ?? 'b')))
				break
			case 'REMOVED':
				branchA.push(changeItem(change, String(change.currentVersion ?? 'a')))
				break
			case 'MODIFIED':
				branchA.push(changeItem(change, String(change.comparedVersion ?? 'a')))
				branchB.push(changeItem(change, String(change.currentVersion ?? 'b')))
				break
			case 'UNCHANGED': {
				const historyId = String(
					change.currentVersion ?? change.comparedVersion ?? 'u',
				)
				branchA.push(changeItem(change, historyId))
				branchB.push(changeItem(change, historyId))
				break
			}
		}
	}

	return { branchA, branchB }
}
